import WorkflowModulConfirmMixin from "./WorkflowModulConfirmMixin";

// @vue/component
export default {
  name: "WorkflowModulConfirm",
  mixins: [
    WorkflowModulConfirmMixin,
  ],
};
